import { THEME } from '../../../components-v2/Theme/theme';

export const mainChartColor = () => {
	// const allColors = Object.keys(THEME.colors.chart);
	// // Filter out used colors
	// const availableColors = allColors.filter(
	// 	colorKey => !usedColors.has(THEME.colors.chart[colorKey as keyof typeof THEME.colors.chart])
	// );
	// // If no available colors, use all colors
	// const colorsToUse = availableColors.length > 0 ? availableColors : allColors;
	// const randomColor = colorsToUse[Math.floor(Math.random() * colorsToUse.length)];
	// return THEME.colors.chart[randomColor as keyof typeof THEME.colors.chart];

	return THEME.colors.chart.levBlue;
};

export const randomChartColor = (usedColors: Set<string> = new Set(), forbiddenColors: Set<string> = new Set()) => {
	const allColors = Object.keys(THEME.colors.chart);
	// Filter out used colors and forbidden colors
	const availableColors = allColors.filter(colorKey => {
		const colorValue = THEME.colors.chart[colorKey as keyof typeof THEME.colors.chart];
		return !usedColors.has(colorValue) && !forbiddenColors.has(colorValue);
	});
	// If no available colors, use all colors (excluding forbidden ones)
	const colorsToUse =
		availableColors.length > 0
			? availableColors
			: allColors.filter(
					colorKey => !forbiddenColors.has(THEME.colors.chart[colorKey as keyof typeof THEME.colors.chart])
				);
	const randomColor = colorsToUse[Math.floor(Math.random() * colorsToUse.length)];
	return THEME.colors.chart[randomColor as keyof typeof THEME.colors.chart];
};
